import { createElementBlock as r, openBlock as o, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 200 201"
};
function n(c, e) {
  return o(), r("svg", l, [...e[0] || (e[0] = [
    t("rect", {
      width: "193",
      height: "193",
      x: "3.5",
      y: "4",
      stroke: "currentColor",
      "stroke-width": "7",
      rx: "96.5"
    }, null, -1),
    t("path", {
      fill: "currentColor",
      d: "M59.546 82.9a1 1 0 0 0-1.414 0l-7.425 7.425a1 1 0 0 0 0 1.414l40.898 40.898 58.576-58.575a1 1 0 0 0 0-1.415l-7.424-7.424a1 1 0 0 0-1.415 0L91.605 114.96z"
    }, null, -1)
  ])]);
}
const a = { render: n };
export {
  a as default,
  n as render
};
